<ion-button
  *ngIf="sidebar?.appearance && !sidebar?.hidden"
  (pointerdown)="pointerDown()"
  (click)="click(index)"
  [tooltip]="sidebars.get(sidebar.appearance)?.name + ' (Ctrl + ' + (index + 1) + ')'"
  [attr.aria-label]="sidebars.get(sidebar?.appearance)?.name + ' (Ctrl + ' + (index + 1) + ')'"
  class="text"
  id="studio-controls-{{ sidebar?.appearance }}-button"
  [class.active-button]="(sidebarItems$ | async)[index]?.open"
  [class.unread]="sidebar?.appearance === 'chat' ? (unreadChatGroups$ | async).length : false"
  [class.head-shake]="editingSidebars$ | async"
  [size]="size">
  <ion-icon
    [src]="
      sidebar?.appearance === 'chat' && (unreadChatGroups$ | async).length
        ? '/assets/icons/32px/chat-active-bold.svg'
        : sidebars.get(sidebar?.appearance)?.icon
    "
    slot="icon-only">
  </ion-icon>
  <div
    (click)="removeSidebar($event, index)"
    *ngIf="sidebar?.appearance && (editingSidebars$ | async) && index !== 0"
    tooltip="Remove Sidebar"
    aria-label="Remove Sidebar"
    class="remove-sidebar"
    [class.small]="size === 'small'">
    <ion-icon src="/assets/icons/24px/close.svg"> </ion-icon>
  </div>
</ion-button>
<ion-button
  *ngIf="!sidebar?.appearance && editingSidebars$ | async"
  (click)="addSidebar($event, index)"
  tooltip="Add Sidebar"
  aria-label="Add Sidebar"
  class="text"
  [class.head-shake]="editingSidebars$ | async"
  id="studio-controls-add-button"
  [size]="size">
  <ion-icon src="/assets/icons/24px/add.svg" slot="icon-only"> </ion-icon>
</ion-button>
